export default "__VITE_ASSET__CItYPgTC__"